import { Injectable } from '@angular/core';
import { AirlinePreferenceKeys } from '@ag-common-lib/lib/models/utils/flight-preference.model';

@Injectable()
export class FlightPreferenceFormService {
  constructor() {}

  getFormData = initialData => {
    if (!Array.isArray(initialData?.airlinePreferences)) {
      initialData.airlinePreferences = [];
    }
    const airlinePreferences = initialData.airlinePreferences;
    if (airlinePreferences?.length) {
      initialData.airlinePreferences[AirlinePreferenceKeys.isFirstChoiceAirline] =
        airlinePreferences[AirlinePreferenceKeys.isFirstChoiceAirline] ?? false;
      initialData.airlinePreferences[AirlinePreferenceKeys.isSecondChoiceAirline] =
        airlinePreferences[AirlinePreferenceKeys.isSecondChoiceAirline] ?? false;
    }

    const formData = new Proxy(initialData ?? { airlinePreferences: [] }, {
      set: (target, prop, value, receiver) => {
        const prevValue = target[prop];
        if (value !== prevValue) {
          Reflect.set(target, prop, value, receiver);
        }
        return true;
      },
    });

    return formData;
  };
}
